import { ModelRequestStatus, Visibility } from '../models/APIModels';
import * as _ from 'lodash';
import * as hash from 'json-hash';

export default {
  keypress(event) {
    // console.log('event.which', event.which)
    if (event.keyCode == 13 || event.keyCode == 9 || event.keyCode === 45) {
      // 13 = Enter key, 9 = tab
      const input = this.$el.querySelector('input') as HTMLInputElement;
      input.blur();
    } else if (event.which < 45 || event.which > 57) {
      // Reject all non-numeric
      event.preventDefault();
    }
  },
  onPaste(evt) {
    evt.preventDefault();
    return false;
  },
  getGridStyle(column: string, widthSize, smallScreen = 900) {
    let style = {};
    if (widthSize && widthSize > smallScreen) {
      if (column === 'left') {
        style = {
          paddingLeft: '10px',
        };
      } else if (column === 'right') {
        style = {
          paddingLeft: '10px',
          borderStyle: 'dotted',
          borderColor: 'rgba(0, 0, 0, 0.12)',
          borderWidth: '0 0 0 2px',
        };
      }
    }
    return style;
  },

  getOSName() {
    let OSName = 'UnKnown OS';
    if (navigator.platform.indexOf('Win') !== -1) OSName = 'Windows';
    if (navigator.platform.indexOf('Mac') !== -1) OSName = 'MacOS';
    if (navigator.platform.indexOf('X11') !== -1) OSName = 'Unix';
    if (navigator.platform.indexOf('Linux') !== -1) OSName = 'Linux';
    if (navigator.platform.indexOf('iPhone') !== -1) OSName = 'iOS';
    if (navigator.platform.indexOf('iPad') !== -1) OSName = 'iOS';
    if (navigator.platform.indexOf('Android') !== -1) OSName = 'Android';

    return OSName;
  },
  /**
   * Shorten a filename
   *
   * @param {string} fileName
   * @param {number} maxLength
   * @returns {string}
   */
  shortenFileName(fileName: string, maxLength: number): string {
    let name = fileName.substr(0, fileName.lastIndexOf('.'));
    let ext = fileName.substr(fileName.lastIndexOf('.') + 1, fileName.length);

    if (name.length > maxLength) {
      name = name.substr(0, maxLength - 3) + '...';
    }
    return name + '.' + ext;
  },
  displayModelType(value) {
    // console.log('value', value)
    let modelType = '';
    switch (value) {
      case 'HostedModel':
        modelType = 'Hosted Model (beta)';
        break;
      case 'IndexedModel':
        modelType = 'AI Model';
        break;
      case 'IndexedService':
        modelType = 'AI Service';
        break;
      default:
        break;
    }
    return modelType;
  },
  showRequestModelStatus(value: ModelRequestStatus) {
    let status = '';
    switch (value) {
      case ModelRequestStatus.UnderReview:
        status = 'Under Review';
        break;
      case ModelRequestStatus.Deleted:
      case ModelRequestStatus.Active:
      case ModelRequestStatus.Draft:
        status = value;
        break;
      default:
        console.error('Unexpected status');
        break;
    }
    return status;
  },
  convertKeyValueToObject(keyPairs) {
    return [...keyPairs].reduce((data, pair) => {
      const key = pair.keyItem;
      const value = pair.valueItem;

      if (key === '') return data;
      return {
        ...data,
        [key]: value,
      };
    }, {});
  },
  /* Function will validate white space /empty string/ null or undefined object
  console.log(isEmpty("cat")); // false
console.log(isEmpty(1)); // false
console.log(isEmpty([])); // false
console.log(isEmpty({})); // false
console.log(isEmpty(false)); // false
console.log(isEmpty(0)); // false
console.log(isEmpty(-0)); // false
console.log(isEmpty(NaN)); // false

console.log(isEmpty("")); // true
console.log(isEmpty("    ")); // true
console.log(isEmpty(null)); // true
console.log(isEmpty(undefined)); // true
*/
  isEmpty(value) {
    return value == null || (typeof value === 'string' && value.trim().length === 0);
  },
  /**
   * convertToQueryString
   *
   * @param {*} input
   * @returns {string}
   */
  isObjectEmpty (objectName)  {
    return Object.keys(objectName).length === 0;
  },
  convertToQueryString(input: any): string {
    if (input === null) return null;
    const qs = Object.keys(input)
      .map((key) => {
        if (_.isArray(input[key])) {
          return _.map(_.omitBy(input[key], _.isNil), (v) => `${encodeURIComponent(key)}=${encodeURIComponent(v)}`);
        } else return `${encodeURIComponent(key)}=${encodeURIComponent(input[key])}`;
      })
      .join('&');
    // console.log('convertToQueryString', input, qs);
    return qs;
  },
  async isImgUrl(url) {
    const img = new Image();
    img.src = url;

    return new Promise((resolve) => {
      img.onerror = () => resolve(false);
      img.onload = () => resolve(true);
    });
  },
  /**
   * Gets a hash to check if a large object has any changes from moment to moment.
   * @param obj Any js object.
   * @returns null if obj is null or undfined, otherwise a hash of the object.
   */
  getChecksum(obj: any) {
    if (obj == null) {
      return null;
    }
    return hash.digest(obj);
  },
  uniqueKeyNameGenForVariableDisplayOptions(inputName: string, customString: string) { 
    return inputName.replace(/\s+/g, '_').toLowerCase() + '_' + customString;
  },
  async copyToClipboard(text: string) {
    try {
      await navigator.clipboard.writeText(text);
      // console.log('Text copied to clipboard!');
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  },
  formatNumberToTwoDecimals(number: number): number {
    // Check if the number is a decimal
    if (isNaN(number)) {
      return number; // Return the original value if not a number
    }

    return parseFloat(number.toFixed(2));
  },
  async checkImageURL(items: any[], favicon: string): Promise<any[]> {
    const checkUrl = async (url: string) => {
      const img = new Image();
      img.src = url;
      return new Promise((resolve) => {
        img.onerror = () => resolve(false);
        img.onload = () => resolve(true);
      });
    };

    // Return the updated array of items wrapped in a promise
    return await Promise.all(
      items.map(async (item) => ({
        ...item,
        favIconUrl: item.favIconUrl && (await checkUrl(item.favIconUrl)) ? item.favIconUrl : favicon,
      }))
    );
  },
};
